import { render } from "./Condoleances.vue?vue&type=template&id=69328202"
import script from "./Condoleances.vue?vue&type=script&lang=js"
export * from "./Condoleances.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__